export const hongbao = {
    hb: "레드 패킷",
    dps: "대규모 증정",
    xdhb: "한정 레드 패킷, 천만 개의 혜택이 당신을 기다립니다",
    fxhb: "레드 패킷 공유하여 더 많은 보상을 얻으세요",
    khb: "레드 패킷 열기",
    kqz: "열리는 중...",
    ylq: "수령 완료",
    hdwks: "이벤트 시작 전",
    hdjxz: "이벤트 진행 중",
    hdyjs: "이벤트 종료됨",
    hddjs: "이벤트 카운트다운",
    hdsj: "이벤트 시간",
    zwhd: "진행 중인 이벤트 없음",
    hblsjlxq: "내 레드 패킷 보상 내역",
    jxz: "진행 중",
    ygq: "만료됨",
    dks: "시작 예정",
    zwjl: "아직 보상 없음",
    wnmztj: "이벤트 참여 조건을 충족하지 않았습니다",
    wxts: "참고사항",
    yhwcrz: "사용자가 KYC 인증 및 휴대폰 번호 연결을 완료했습니다",
    yhwcjy: "사용자가 다음 조건 중 하나를 완료: 현물 거래 ≥100 USDT 또는 계약 거래(레버리지 제외) ≥100 USDT 또는 옵션 거래 ≥100 USDT 또는 GameFi 거래 ≥100 USDT",
    djzh: "리스크 관리 또는 출금 제한 계정은 이벤트에 참여할 수 없습니다.",
    hdhbjl: "보상 획득",
    sqbj: "운이 나쁘네요",
    dkapp: "앱 열기",
    smewm: "QR 코드 스캔",
    wchdtj: "이벤트 조건 완료 후 레드 패킷 수령",
    fxhd: "이벤트 공유하여 더 많은 레드 패킷 획득",
    jdcz: "간단한 조작으로 수익 창출",
    hdhb: "이벤트 레드 패킷",
    zdqj: "지정 기간",
    wcjye: "{type} 거래액 {text} ≥ {amount} USDT 완료",
    yhwfhtj: "레드 패킷 출시 전 {time} 동안 사용자는 조건에 맞는 거래가 없었습니다",
    hbsxq: "레드 패킷 출시 전 {time}{day} 동안 사용자는 {text}",
    bhgg: "레버리지 제외",
    h: " 또는 ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/kr.js